module.exports = __webpack_public_path__ + "img/Cutaways_house_2_a.0f84c696.jpg";